import { action, noop } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui/error-snackbar'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { cancelLimitOrderRequestAction } from './limit-order-requests'

import type { LimitOrderId } from '@root/entities/limit-order/model/limit-order-id'

export const reatomCancelLimitOrder = ({
  orderId,
}: {
  orderId: LimitOrderId
}) => {
  const {
    executeAction: cancelOrderAction,
    requestStateAtom: cancelStateAtom,
    resetStateAction: resetCancelOrderAtom,
  } = reatomRequest({
    execAction: cancelLimitOrderRequestAction,
    name: 'reatomCancelLimitOrder',
    prepare: (ctx) => ({ network: ctx.get(selectedNetworkAtom), id: orderId }),
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        showErrorSnackbarAction(ctx, result.failure)
        return
      }

      showSnackbarAction(ctx, {
        text: i18next.t('order.close-order-completed'),
        intent: 'success',
      })
    },
  })

  return {
    cancelOrderAction,
    cancelStateAtom,
    resetCancelOrderAtom,
  }
}

export const openCancelLimitOrderDrawerEvent = action<
  [{ orderId: LimitOrderId }]
>(noop, 'openCancelLimitOrderDrawerEvent')
